import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Mail, Send, Loader2 } from "lucide-react";

export const DigestSettings = () => {
  const [email, setEmail] = useState("");
  const [enabled, setEnabled] = useState(false);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    api.get("/digest/settings").then((r) => {
      setEmail(r.data.recipient_email || "");
      setEnabled(r.data.enabled || false);
    }).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/digest/settings", { recipient_email: email, enabled });
      toast.success("Digest settings saved — daily email at 8:00 AM IST");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  const sendTest = async () => {
    setSending(true);
    try {
      await api.post("/digest/send-test");
      toast.success(`Test digest sent to ${email}`);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setSending(false); }
  };

  return (
    <div data-testid="digest-settings-panel" className="bg-[#1E293B] border border-[#334155] rounded-lg p-5">
      <h3 className="text-base font-semibold mb-1 flex items-center gap-2" style={{ fontFamily: "Outfit, sans-serif" }}>
        <Mail className="h-4 w-4 text-emerald-400" /> Daily Morning Digest
      </h3>
      <p className="text-xs text-slate-400 mb-4">Yesterday's billing, old stock alerts & FIFO picks — every day at 8:00 AM IST.</p>
      <form onSubmit={save} className="space-y-3">
        <Input data-testid="digest-email-input" required type="email" placeholder="you@yourbusiness.com" value={email}
          onChange={(e) => setEmail(e.target.value)} className="bg-[#0B0F17] border-[#334155] text-slate-100 placeholder:text-slate-500" />
        <div className="flex items-center justify-between">
          <span className="text-xs text-slate-300">Daily sending enabled</span>
          <Switch data-testid="digest-enabled-switch" checked={enabled} onCheckedChange={setEnabled} />
        </div>
        <div className="flex gap-2">
          <Button data-testid="save-digest-btn" type="submit" className="flex-1 bg-emerald-600 hover:bg-emerald-500 text-white active:scale-95 transition-colors">Save</Button>
          <Button data-testid="send-test-digest-btn" type="button" onClick={sendTest} disabled={sending || !email}
            variant="outline" className="border-[#334155] text-slate-300 hover:bg-slate-800 hover:text-white">
            {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
            <span className="ml-1.5">Test</span>
          </Button>
        </div>
      </form>
    </div>
  );
};
